<template>
  <!-- Conteneur principal des concepts avec gestion du scroll -->
  <div class="concept-container ans-mw px-0 ">

    <!-- Suggestions de concepts -->
    <ConceptSuggestions :suggestions="store.suggestions" />
    <!-- Affichage de la liste des concepts -->
    <v-container v-for="(item, index) in store.conceptsList" :key="index" class="px-0" v-show="item.hidden !== true"
      style="padding-top: 3px;">
      <ConceptResult :concept="item" :targetLang="$route.query.lang" />
    </v-container>
    <!-- Bouton pour charger plus de concepts si disponible -->
    <div v-if="hasMoreConcepts" class="text-center py-4">
      <v-btn fab small color="primary" @click="loadMoreConcepts" style=" background-color: var(--primary);">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
// Importation du store et des composants nécessaires
import ConceptsStore from "../concepts-store";
import ConceptResult from "./ConceptResult";
import ConceptSuggestions from './ConceptSuggestions';

export default {
  name: "Concepts",

  components: {
    ConceptResult, // Composant pour afficher un concept
    ConceptSuggestions, // Composant pour afficher les suggestions
  },

  computed: {
    // Vérifie s'il reste des concepts à charger
    hasMoreConcepts() {
      return this.store.conceptsList.length < this.store.numberOfConcepts;
    }
  },

  data() {
    return {
      store: ConceptsStore.state, // Accès à l'état du store
      currentPageNumber: 1, // Numéro de la page courante pour la pagination
    }
  },

  methods: {
    /**
     * Charge plus de concepts depuis le store
     * @return {void}
     */
    async loadMoreConcepts() {
      const terminologyIds = this.store.facets.options.all
        .filter(option => option.checked === true)
        .map(option => option.id);
      this.currentPageNumber += 1;
      this.store.page = this.currentPageNumber;
      await ConceptsStore.searchConcepts(true, terminologyIds, true);
      this.$emit('loadmore');
    },
  }

}
</script>